module.exports = __webpack_public_path__ + "media/Goat1.26a30fe6.ogg";